import React, { useState, useEffect, useRef } from 'react';

const AdSense = ({ 
  adSlot, 
  adFormat = 'auto', 
  className = "",
  showFallback = false 
}) => {
  const [adState, setAdState] = useState('loading'); // loading, loaded, failed, blocked
  const [showAd, setShowAd] = useState(false);
  const adRef = useRef(null);

  useEffect(() => {
    const loadAd = async () => {
      try {
        // Wait a bit for page to settle
        await new Promise(resolve => setTimeout(resolve, 500));

        // Check if AdSense script is available
        if (typeof window.adsbygoogle === 'undefined') {
          // Give it more time to load
          await new Promise(resolve => setTimeout(resolve, 2000));
          
          if (typeof window.adsbygoogle === 'undefined') {
            setAdState('failed');
            return;
          }
        }

        // Check for ad blockers (simple detection)
        const testAd = document.createElement('div');
        testAd.innerHTML = '&nbsp;';
        testAd.className = 'adsbox';
        document.body.appendChild(testAd);
        
        await new Promise(resolve => setTimeout(resolve, 100));
        
        const isBlocked = testAd.offsetHeight === 0;
        document.body.removeChild(testAd);
        
        if (isBlocked) {
          setAdState('blocked');
          return;
        }

        // Load the actual ad
        if (adRef.current) {
          try {
            (window.adsbygoogle = window.adsbygoogle || []).push({});
            
            // Check if ad loaded successfully
            setTimeout(() => {
              if (adRef.current) {
                const hasContent = adRef.current.innerHTML.trim() !== '' && 
                                 adRef.current.querySelector('iframe, ins[data-ad-status="filled"]');
                
                if (hasContent) {
                  setAdState('loaded');
                  setShowAd(true);
                } else {
                  setAdState('failed');
                }
              }
            }, 1000);
          } catch (error) {
            console.log('AdSense push failed:', error);
            setAdState('failed');
          }
        }

      } catch (error) {
        console.log('Ad loading error:', error);
        setAdState('failed');
      }
    };

    loadAd();

    // Cleanup timeout on unmount
    return () => {
      if (adRef.current) {
        // Clean up any pending ad requests
      }
    };
  }, [adSlot]);

  // Don't render anything if ad hasn't loaded or failed
  if (adState === 'loading') {
    return null; // No empty box!
  }

  // Optional: Show fallback message for blocked/failed ads
  if ((adState === 'failed' || adState === 'blocked') && showFallback) {
    return (
      <div className={`bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-lg p-3 text-center ${className}`}>
        <p className="text-blue-600 text-sm">📢 Support us by disabling ad blocker</p>
        <p className="text-blue-400 text-xs">Ads help keep this service free</p>
      </div>
    );
  }

  
  if (adState === 'failed' || adState === 'blocked') {
    return null;
  }

  
  if (adState === 'loaded' && showAd) {
    return (
      <div className={`bg-white rounded-2xl p-4 shadow-lg border transition-opacity duration-300 ${className}`}>
        <ins
          className="adsbygoogle"
          style={{ 
            display: 'block',
            minHeight: adFormat === 'rectangle' ? '250px' : 'auto'
          }}
          data-ad-client="ca-pub-3325592373283227"
          data-ad-slot={adSlot}
          data-ad-format={adFormat}
          data-full-width-responsive="true"
          ref={adRef}
        />
      </div>
    );
  }

  return null;
};

export default AdSense;